import { Tool } from '@/data/tools';
import ToolCard from './ToolCard';
import { motion, AnimatePresence } from 'framer-motion';

interface ToolGridProps {
  tools: Tool[];
}

export default function ToolGrid({ tools }: ToolGridProps) {
  if (tools.length === 0) {
    return (
      <div className="max-w-[1240px] mx-auto px-6 py-32 text-center bg-white dark:bg-slate-900 border border-gray-100 dark:border-white/5 rounded-[3rem] shadow-sm transition-colors duration-500">
        <div className="inline-flex items-center justify-center w-24 h-24 rounded-[2rem] bg-gray-50 dark:bg-blue-500/10 mb-8 border border-gray-100 dark:border-blue-500/20">
          <svg className="w-12 h-12 text-gray-400 dark:text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
        </div>
        <h3 className="text-3xl font-black text-gray-900 dark:text-white mb-4 tracking-tight">No tools found</h3>
        <p className="text-gray-500 dark:text-gray-400 max-w-md mx-auto text-lg font-medium leading-relaxed">
          We couldn't find any tools matching your criteria. Try adjusting your search or category filters.
        </p>
      </div>

    );
  }

  return (
    <div className="max-w-[1240px] mx-auto px-6 pb-20">
      <motion.div 
        layout
        className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 md:gap-6"
      >
        <AnimatePresence mode="popLayout">
          {tools.map((tool, index) => (
            <ToolCard key={tool.id} tool={tool} index={index} />
          ))}
        </AnimatePresence>
      </motion.div>
    </div>
  );
}
